/* eslint-disable  */
import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";
import useProductHook from "../../../inventory/products/useProductHook";

function ProductAutocomplete({
  value,
  onChange = () => {},
  onAddNew = () => {},
}) {
  const [inputValue, setInputValue] = useState(value ? value?.label : "");
  const { Products, submitProductMutation } = useProductHook({
    search: inputValue,
  });
  const [defaultOptions, setDefaultOptions] = useState([]);

  useEffect(() => {
    const options = Products?.map((p) => ({
      label: p.name,
      value: p.id,
    }));
    setDefaultOptions(options);
  }, [Products]);

  const loadOptions = async (input) => {
    let options = Products?.map((p) => ({
      label: p.name,
      value: p.id.toString(),
    }));
    if (Products.length == 0 && inputValue) {
      options.push({
        label: `Add "${input}"`,
        value: "__add_new__",
        isNew: true,
      });
    }
    console.log("optins1 ", options, value, Products.length == 0, Products);

    if (value && value.name !== "") {
      options.push({
        label: value.name,
        value: value.id.toString(),
      });
    }
    console.log("optins ", options, input, Products.length == 0, Products);
    return options;
  };

  const handleChange = (option) => {
    if (option?.isNew) {
      console.log("opt", option);
      onAddNew(option.input);
      submitProductMutation.mutate(
        { name: inputValue },
        {
          onSuccess: (data) => {
            onChange({
              label: data?.data?.name,
              value: data?.data?.id.toString(),
            });
          },
          onError: (error) => {
            console.error("Error adding product:", error);
          },
        }
      );
    } else if (option?.value && option?.value !== "__add_new__") {
      onChange({ label: option?.label, value: option?.value.toString() });
    } else {
      onChange(null);
    }
  };

  const handleInputChange = (input) => {
    setInputValue(input);
    return input;
  };
  return (
    <AsyncSelect
      value={value ? { label: value.label, value: value.value } : null}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      placeholder="Select or add product"
      isClearable
      menuPosition="fixed"
      defaultOptions={defaultOptions}
      styles={{
        menu: (base) => ({ ...base, zIndex: 9999 }),
        control: (base) => ({ ...base, minWidth: 250, maxWidth: 250 }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
}

export default ProductAutocomplete;
